module.exports = __webpack_public_path__ + "static/img/distribuicao-notas.6904aed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/distribuicao-notas.png
// module id = 7yhD
// module chunks = 1